export const searchInfo = {
  glyph: 'search',
  label: 'Search',
  placeholder: 'Enter a term',
  searchList: [],
};
